import { render, staticRenderFns } from "./MeasureEditor.vue?vue&type=template&id=32dc61cf&scoped=true"
import script from "./MeasureEditor.vue?vue&type=script&lang=js"
export * from "./MeasureEditor.vue?vue&type=script&lang=js"
import style0 from "./MeasureEditor.vue?vue&type=style&index=0&id=32dc61cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc61cf",
  null
  
)

export default component.exports